import React, { useMemo } from 'react';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Suspense, lazy } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import Header from '../../header';
import './User.css';
import { IconArrowLeft, IconArrowRight, IconCalendar, IconChevronLeft, IconChevronRight, IconCircleArrowUp } from "@tabler/icons-react";
import dayjs from 'dayjs';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { readPatientUuidFromLocation, setSelectedPatient } from '../../auth/patientContext';
//import bodyIco from '../../images/body.svg';
import medicinIco from '../../images/medicines.svg';
import bpIco from '../../images/blood-pressure.svg';
import fgIco from '../../images/fg.svg';
import pulsIco from '../../images/puls.svg';
import scIco from '../../images/sc.svg';
import stressIco from '../../images/stress.svg';
import wtIco from '../../images/weight.svg';
import htIco from '../../images/height.svg';
import chatIco from '../../images/chat.svg';
import { PDFDownloadLink, Document, Page, View, Image, Text } from '@react-pdf/renderer';
import userImage from '../../images/user.svg';
import { ChatbotModal } from '../ChatbotModal/ChatbotModal';

/*import Usermeals from '../Usermeals/Usermeals';
import Userappointment from '../Userappointment/Userappointment'
import Userexercise from '../Userexercise/Userexercise';
import Insights from '../Insights/Insights';
import Userglucose from '../Userglucose/Userglucose';
import Loader from '../Loader/Loader';
import Userwellnessprofile from '../Userwellnessprofile/Userwellnessprofile';
import Userweightheight from '../Userweightheight/Userweightheight';*/

const Loader = React.lazy(() => import("../Loader/Loader.js"));
//const Chatappbox = React.lazy(() => import("../Chatsendbird/Chatapp.js")) 
//const Userappointment = React.lazy(() => import("../Userappointment/Userappointment.js"));
const Userexercise = React.lazy(() => import("../Userexercise/Userexercise.js"));
const Insights = React.lazy(() => import("../Insights/Insights.js"));
const Userwellnessprofile = React.lazy(() => import("../Userwellnessprofile/Userwellnessprofile.js"));
const Userweightheight = React.lazy(() => import("../Userweightheight/Userweightheight.js"));
//const UserChat = React.lazy(() => import("../Chat/Chat.js"));
const Usermeals = React.lazy(() => import("../Usermeals/Usermeals.js"));
const Userglucose = React.lazy(() => import("../Userglucose/Userglucose.js"));
const CalorieTracker = React.lazy(() => import("../CalorieTracker/CalorieTracker.js"));

const base_url = process.env.REACT_APP_BASE_URL;

function User() {

  const [startDate, setStartDate] = useState([{}]);
  const [secondaryComponentsReady, setSecondaryComponentsReady] = useState(false);
  const DATE = localStorage.getItem("DATE");

  if (DATE === '' || DATE === null) {
    localStorage.setItem("DATE", (moment()).format('YYYY-MM-DD'));
  }

  const setDate = (date) => {
    localStorage.setItem("DATE", moment(date, 'YYYY-MM-DD').format("YYYY-MM-DD"));
  }

  const startDay = moment(DATE).startOf('isoWeek').format('MMM DD');
  const endDay = moment(DATE).endOf('isoWeek').format('MMM DD');

  const changeWeek = () => {
    var a = moment(DATE).subtract(1, 'weeks').endOf('isoWeek').format('YYYY-MM-DD');
    localStorage.setItem("DATE", moment(a, 'YYYY-MM-DD').format("YYYY-MM-DD"));
    refresh()
  }
  const changeWeekNxt = () => {
    var a = moment(DATE).add(1, 'weeks').endOf('isoWeek').format('YYYY-MM-DD');
    localStorage.setItem("DATE", moment(a, 'YYYY-MM-DD').format("YYYY-MM-DD"));
    refresh()
  }

  const [profileData, setProfileData] = useState([]);
  const [doctorData, setDoctorData] = useState([]);

  const UID = readPatientUuidFromLocation();
  const UDATE = DATE;
  const user = localStorage.getItem("user").replace(/['"]+/g, '');
  const [nxtUser, setnxt] = useState([{}]);
  const [prvUser, setprv] = useState([{}]);
  const role = localStorage.getItem("userrole");
  const userName = localStorage.getItem("userName");
  const gname = localStorage.getItem("userGroup");

  // Ensure UUID is always treated as string
  const userload = {
    "uuid": UID ? String(UID) : "",
    "date": UDATE
  }

  const [loadingg, setloading] = useState(true);
  const [loading1, setloading1] = useState(true);
  const [loading2, setloading2] = useState(true);

  const [highRanges, setHighRanges] = useState([]);
  const [lowRanges, setLowRanges] = useState([]);
  const [latestSleepDuration, setLatestSleepDuration] = useState(null);
  const [latestPulse, setLatestPulse] = useState(null);
  const [latestStressLevel, setLatestStressLevel] = useState(null);
  const [weightData, setWeightData] = useState(null);
  const [userNotes, setUserNotes] = useState([]);
  const [dailyInsight, setDailyInsight] = useState(null);
  const [weeklyInsight, setWeeklyInsight] = useState(null);
  const [showWeekly, setShowWeekly] = useState(false);
  const [userDevices, setUserDevices] = useState([]);
  const [userPlatform, setUserPlatform] = useState(null);
  const [lastActiveUpdated, setLastActiveUpdated] = useState(false);

  const currentDeviceId = userDevices.length > 0
    ? (userDevices[userDevices.length - 1]?.bt_name || null)
    : null;

  const sensorStartData = useMemo(() => {
    if (!userDevices.length) return null;
    const device = userDevices[userDevices.length - 1];
    if (!device) return null;
    return {
      start_date: device.boot_at ? new Date(device.boot_at * 1000) : null,
      end_date: device.expire_at ? new Date(device.expire_at * 1000) : null,
    };
  }, [userDevices]);

  const navigate = useNavigate();
  const logout = async (e) => {
    try {
      const { logout: clearSession } = await import("../../auth/session");
      await clearSession(base_url);
    } catch (_) {
      localStorage.clear();
    }
    navigate('/Login');
  }

  async function fetchBloodPressure(uuid, start_date, end_date) {
    const token = localStorage.getItem("user");
    const response = await fetch(base_url + '/graph/blood-pressure', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ uuid, start_date, end_date }),
    });
    const data = await response.json();

    // Find the latest entry with values
    let latestEntry = null;
    if (data.response && Array.isArray(data.response)) {
      for (const item of data.response) {
        if (item.values && Array.isArray(item.values) && item.values.length === 2) {
          latestEntry = item;
          break; // Get the first entry with values (most recent)
        }
      }
    }

    // Set the latest values if found
    if (latestEntry) {
      setHighRanges([latestEntry.values[1]]); // High (systolic)
      setLowRanges([latestEntry.values[0]]);  // Low (diastolic)
    } else {
      setHighRanges([]);
      setLowRanges([]);
    }
  }

  async function fetchSleepData(uuid, start_date, end_date) {
    const token = localStorage.getItem("user");
    const response = await fetch(base_url + '/graph/sleep', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ uuid, start_date, end_date }),
    });
    const data = await response.json();

    // Find the latest entry with duration
    let latestEntry = null;
    if (data.response && Array.isArray(data.response)) {
      for (const item of data.response) {
        if (item.duration) {
          latestEntry = item;
          break; // Get the first entry with duration (most recent)
        }
      }
    }

    // Set the latest sleep duration if found
    if (latestEntry) {
      setLatestSleepDuration(latestEntry.duration);
    } else {
      setLatestSleepDuration(null);
    }
  }

  async function fetchPulseData(uuid, start_date, end_date) {
    const token = localStorage.getItem("user");
    const response = await fetch(base_url + '/graph/pulse', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ uuid, start_date, end_date }),
    });
    const data = await response.json();

    // Find the latest entry with pulse
    let latestEntry = null;
    if (data.response && Array.isArray(data.response)) {
      for (const item of data.response) {
        if (item.pulse) {
          latestEntry = item;
          break; // Get the first entry with pulse (most recent)
        }
      }
    }

    // Set the latest pulse if found
    if (latestEntry) {
      setLatestPulse(latestEntry.pulse);
    } else {
      setLatestPulse(null);
    }
  }

  async function fetchStressLevel(uuid, start_date, end_date) {
    const token = localStorage.getItem("user");
    const response = await fetch(base_url + '/graph/stress-level', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ uuid, start_date, end_date }),
    });
    const data = await response.json();

    // Find the latest entry with stress level
    let latestEntry = null;
    if (data.response && Array.isArray(data.response)) {
      for (const item of data.response) {
        if (item.stress_level) {
          latestEntry = item;
          break; // Get the first entry with stress level (most recent)
        }
      }
    }

    // Set the latest stress level if found
    if (latestEntry) {
      setLatestStressLevel(latestEntry.stress_level);
    } else {
      setLatestStressLevel(null);
    }
  }

  async function fetchUserNotes(uuid) {
    const token = localStorage.getItem("user");
    try {
      const response = await fetch(`${base_url}/notes/get-notes?userId=${uuid}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();

      if (data.status === 200 && Array.isArray(data.response)) {
        // Sort notes chronologically (newest first)
        const sortedNotes = data.response.sort((a, b) => 
          new Date(b.created_at) - new Date(a.created_at)
        );
        setUserNotes(sortedNotes);
      } else {
        setUserNotes([]);
      }
    } catch (error) {
      console.error('Error fetching notes:', error);
      setUserNotes([]);
    }
  }

  async function fetchAiInsights(uuid) {
    const token = localStorage.getItem("user");
    try {
      // Fetch both daily and weekly insights from the last 7 days
      // Note: base_url already includes /api, so we don't need to add it again
      const apiUrl = `${base_url}/ai-health-insights?user_uuid=${uuid}&last_n_days=7&exclude_weekly=false`;
      
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      
      const data = await response.json();

      if (data.status === 200 && Array.isArray(data.data)) {
        // Data is already ordered by most recent first (analysis_date DESC, generated_at DESC)
        // Filter to get the most recent daily insight (record_id format: {uuid}::{date})
        const dailyInsights = data.data.filter(insight => 
          insight.record_id && !insight.record_id.includes('::weekly::')
        );
        
        // Filter to get the most recent weekly insight (record_id format: {uuid}::weekly::{start}::{end})
        const weeklyInsights = data.data.filter(insight => 
          insight.record_id && insight.record_id.includes('::weekly::')
        );
        
        // Set the most recent daily insight (first item after filtering)
        setDailyInsight(dailyInsights.length > 0 ? dailyInsights[0] : null);
        
        // Set the most recent weekly insight (first item after filtering)
        setWeeklyInsight(weeklyInsights.length > 0 ? weeklyInsights[0] : null);
      } else {
        setDailyInsight(null);
        setWeeklyInsight(null);
      }
    } catch (error) {
      console.error('Error fetching AI insights:', error);
      setDailyInsight(null);
      setWeeklyInsight(null);
    }
  }

  async function fetchUserDevices(email) {
    if (!email) return;
    const token = localStorage.getItem("user");
    try {
      const response = await axios.post(`${base_url}/admin/influxdb/user-devices`, 
        { email },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );
      if (response.data?.devices && Array.isArray(response.data.devices)) {
        setUserDevices(response.data.devices);
        // Store device boot/expire dates in localStorage for child components (AGP chart, glucose charts)
        const latestDevice = response.data.devices[response.data.devices.length - 1];
        if (latestDevice) {
          localStorage.setItem("deviceBootAt", latestDevice.boot_at || "");
          localStorage.setItem("deviceExpireAt", latestDevice.expire_at || "");
        }
      }
    } catch (error) {
      console.error('Error fetching user devices:', error);
    }
  }

  async function fetchUserPlatform(uuid, email) {
    if (!uuid || !email) return;
    const token = localStorage.getItem("user");
    try {
      const response = await axios.post(
        `${base_url}/admin/influxdb/glucose-data?aggregate=daily`,
        {
          uuid,
          email,
          start_date: DATE,
          end_date: DATE,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );
      // Only use user_platform - no fallback to legacy device field
      if (response.data?.user_platform) {
        setUserPlatform(response.data.user_platform);
      }
    } catch (error) {
      console.error('Error fetching user platform:', error);
    }
  }

  async function checkAndUpdateLastActive(uuid, email) {
    if (!uuid || !email || lastActiveUpdated) {
      return;
    }
    const token = localStorage.getItem("user");
    const currentDate = moment().format('YYYY-MM-DD');
    
    // Only check if the selected DATE is today
    if (DATE !== currentDate) {
      return;
    }
    
    try {
      // Fetch glucose data for today to check if readings exist
      const response = await axios.post(
        `${base_url}/admin/influxdb/glucose-data?aggregate=5min`,
        {
          uuid,
          email,
          start_date: currentDate,
          end_date: currentDate,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );
      
      
      // Store glucose ranges in localStorage if present
      if (response.data?.glucose_data_of_user?.[0]) {
        const ranges = response.data.glucose_data_of_user[0];
        if (ranges.lower_range && ranges.upper_range) {
          localStorage.setItem('glucose_ranges', JSON.stringify({
            uuid,
            lower_range: Math.round(Number(ranges.lower_range)),
            upper_range: Math.round(Number(ranges.upper_range))
          }));
        }
      }
      
      // Check if there are glucose readings for today
      if (response.data?.response !== "Error while fetching data") {
        const cgmData = response.data?.response?.cgm_data || [];
        if (cgmData && cgmData.length > 0) {
          // Update last_active time for the user
          await updateLastActiveTime(uuid, token);
          setLastActiveUpdated(true);
        } else {
        }
      } else {
      }
    } catch (error) {
      console.error('Error checking glucose readings for last_active update:', error);
    }
  }

  async function updateLastActiveTime(uuid, token) {
    if (!uuid || !token) return;
    
    // Get device info from profileData (if available)
    const userProfile = profileData.length > 0 ? profileData[0] : null;
    const deviceInfo = {
      device: userProfile?.device || 'Unknown',
      device_name: userProfile?.device_name || 'Unknown',
      device_version: userProfile?.device_version || 'Unknown',
      app_version: userProfile?.app_version || 'Unknown'
    };
    
    try {
      // Update last_active to current date (Unix timestamp)
      const currentTimestamp = moment().unix();
      
      // Use the new endpoint that doesn't require authentication
      const response = await axios.post(
        `${base_url}/auth/update-user-details`,
        {
          uuid: uuid,
          last_active: currentTimestamp,
          app_version: deviceInfo.app_version,
          device_version: deviceInfo.device_version,
          device: deviceInfo.device,
          device_name: deviceInfo.device_name
        }
      );
      // Optionally refresh user data to show updated last_active
      if (response.status === 200) {
        // Refresh profile data to show updated last_active
        getData();
      }
    } catch (error) {
      console.error('Error updating last_active time:', error.response?.status, error.response?.data, error.message);
    }
  }

  function getData() {
    // user Basic info
    axios({
      method: "post",
      url: base_url + "/admin/user/get-user",
      data: userload,
      'Content-Type': 'application/json',
      headers: { "Authorization": `Bearer ${user}` }
    }).then((response) => {
      localStorage.removeItem('channel');
      localStorage.removeItem('group');

      // Ensure the response data is properly formatted
      if (response.data.response && Array.isArray(response.data.response)) {
        // Transform the data to ensure consistent format
        const transformedData = response.data.response.map(user => ({
          ...user,
          uuid: String(user.uuid), // Ensure UUID is string
          dob: user.dob || null,
          last_active: user.last_active || null,
          created_at: user.created_at || null,
          updated_at: user.updated_at || null,
          height: user.height || null,
          weight: user.weight || null,
          glucose_level: user.glucose_level || null,
          device: user.device || null,
          device_name: user.device_name || null,
          device_version: user.device_version || null,
          app_version: user.app_version || null,
          group_name: user.group_name || null,
          email: user.email || null,
          mobile_number: user.mobile_number || null,
          firstname: user.firstname || '',
          lastname: user.lastname || '',
          gender: user.gender || null,
          goal: user.goal || null,
          height_unit: user.height_unit || 'cm',
          weight_unit: user.weight_unit || 'kg'
        }));
        setProfileData(transformedData);
      } else {
        setProfileData([]);
      }

      if (response.data?.channel_name?.[0]?.channel_name) {
        localStorage.setItem('channel', response.data?.channel_name?.[0]?.channel_name)
        localStorage.setItem('group', response.data?.group)
      }
      if (role === 'coach' && (gname === null || gname === '')) {
        navigate('/Mygroups');
      }
      setloading1(false);
    }).catch((e) => {
      if (e.message === "Request failed with status code 401") {
        logout();
      }
    })
  }

  function userList() {
    axios({
      method: "get",
      url: base_url + "/admin/user/get-all-uuids",
      'Content-Type': 'application/json',
      headers: { "Authorization": `Bearer ${user}` }
    }).then((response) => {
      let lLen = (response.data.response).length;
      // Convert both the current UID and array items to strings for comparison
      let i = (response.data.response).findIndex((obj) => String(obj) === String(UID));

      if (i < 1) {
        setnxt('undefined');
        setnxt((response.data.response)[i + 1]);
      } else if ((i + 1) === lLen) {
        setnxt('undefined');
        setprv((response.data.response)[i - 1]);
      } else {
        setnxt((response.data.response)[i + 1]);
        setprv((response.data.response)[i - 1]);
      }
      setloading(false);
    }).catch((e) => {
      if (e.message === "Request failed with status code 401") {
        logout();
      }
    })
  }





  function getWeightData() {
    axios({
      method: "post",
      url: base_url + "/other/mydata-get-weight",
      data: { uuid: UID ? String(UID) : "", date: DATE },
      'Content-Type': 'application/json',
      headers: { "Authorization": `Bearer ${user}` }
    }).then((response) => {
      if (response.data.status === 200 && response.data.response) {
        const weightArr = response.data.response.weight || response.data.response;
        if (Array.isArray(weightArr) && weightArr.length > 0) {
          setWeightData(weightArr[0]);
        }
      }
    }).catch((e) => {
      console.error('Error fetching weight data:', e.message);
    });
  }

  async function getData1() {
    // user Basic info - fetch doctors shared with this specific user
    if (!UID) return;
    try {
      const response = await axios({ 
        method: "get", 
        url: base_url + "/admin/get-shared-patient-record", 
        params: { uuid: UID },
        'Content-Type': 'application/json', 
        headers: { "Authorization": `Bearer ${user}` } 
      })
      // Backend should filter by patient UUID, but if it doesn't, we can't filter client-side
      // because records only contain doctor info (doctor UUID), not patient UUID
      const records = response.data.records || [];
      // TODO: Backend needs to filter /admin/get-shared-patient-record by uuid query param
      // For now, show empty if backend returns records for all users (indicates backend bug)
      // Only show records if backend actually filtered (we can't verify this client-side)
      setDoctorData(records);
    } catch (error) {
      console.error('Error fetching shared patient records:', error);
      setDoctorData([]);
    } finally {
      setloading2(false);
    }
  }


  const [today, setToday] = useState('');
  const [ready, setReady] = useState(false);




  useEffect(() => {
    if (loadingg === true) { userList(); }
    if (loading1 === true) { getData(); getWeightData(); }
    if (loading2 === true) { getData1(); }


    if (UID === "" || UID === null) {
      <Navigate to="/Dashboard" ></Navigate>
    }
    
    // Check if UID changed - clear stale email to prevent showing old user's data
    const storedUID = localStorage.getItem('UID')?.replace(/['"]+/g, '');
    if (storedUID !== UID) {
      localStorage.removeItem('email'); // Clear stale email before setting new UID
      setLastActiveUpdated(false); // Reset last active update flag when UID changes
    }
    
    localStorage.setItem('UID', JSON.stringify(UID));
    localStorage.setItem('UDATE', JSON.stringify(UDATE));
    if (profileData.length > 0) {
      localStorage.setItem('email', profileData[0].email);
    }


    // Only attempt to load data if profileData is available
    if (profileData.length > 0) {
      const checkElements = () => {
        const header1 = document.getElementById('header1');
        const screen6 = document.getElementById('screen6');

        if (header1 && screen6) {
          // Add a small delay to ensure all child elements are rendered
          setTimeout(() => {
            DataLoad();
          }, 1000);
        } else {
          // If elements are not found, retry after a short delay
          setTimeout(checkElements, 500);
        }
      };

      checkElements();
    }

    if (UID) {
      const currentDate = moment().format('YYYY-MM-DD');
      const startDate = moment().subtract(30, 'days').format('YYYY-MM-DD'); // Last 30 days
      // Fetch all user health data in parallel for faster loading
      Promise.all([
        fetchBloodPressure(UID, startDate, currentDate),
        fetchSleepData(UID, startDate, currentDate),
        fetchPulseData(UID, startDate, currentDate),
        fetchStressLevel(UID, startDate, currentDate),
        fetchUserNotes(UID),
        fetchAiInsights(UID)
      ]);
    }

    // Fetch user devices and platform when we have the email from profileData
    if (profileData.length > 0 && profileData[0].email) {
      fetchUserDevices(profileData[0].email);
      fetchUserPlatform(UID, profileData[0].email);
      // Check for glucose readings for today and update last_active if found
      checkAndUpdateLastActive(UID, profileData[0].email);
    }

  }, [today, startDate, profileData, Loader, PDFDownloadLink]);

  // Delay loading secondary components (meals, exercise, calories) to prioritize glucose charts
  useEffect(() => {
    // Reset when UID changes
    setSecondaryComponentsReady(false);
    
    if (UID) {
      // Wait 2 seconds before loading secondary components
      const timer = setTimeout(() => {
        setSecondaryComponentsReady(true);
      }, 2000);
      
      return () => clearTimeout(timer);
    }
  }, [UID]);

  // Reset lastActiveUpdated flag when DATE changes to allow re-checking
  useEffect(() => {
    setLastActiveUpdated(false);
  }, [DATE]);



  /*   const logoutforadmin = (e) => {
      let keysToRemove = ["user", "DATE", "userrole", "userName", "email"];
      keysToRemove.forEach(k =>
        localStorage.removeItem(k))
      navigate('/Adminlogin');
    } */



  const refresh = () => (setTimeout(function () { window.location.reload(true) }, 1000));
  const resetTime = () => (localStorage.setItem("DATE", (moment()).format('YYYY-MM-DD')));


  const [toggle, setToggle] = useState(true);
  function toggleActive() { if (toggle === true) { setToggle(false) } else { setToggle(true) } }


  const [load, setdataImg] = useState('');
  const [load1, setdataImg1] = useState('');
  const [load2, setdataImg2] = useState('');
  const [load3, setdataImg3] = useState('');
  const [load4, setdataImg4] = useState('');
  const [load5, setdataImg5] = useState('');
  const [load6, setdataImg6] = useState('');
  const [load7, setdataImg7] = useState('');
  const [load8, setdataImg8] = useState('');
  const [load9, setdataImg9] = useState('');

  var htmlToImage = require("html-to-image");

  const DataLoad = async () => {
    try {
      const elements = {
        header1: document.getElementById('header1'),
        screen1: document.getElementById('screen1'),
        screen2: document.getElementById('screen2'),
        screen3: document.getElementById('screen3'),
        screen4: document.getElementById('screen4'),
        screen5: document.getElementById('screen5'),
        screen6: document.getElementById('screen6'),
        screen7: document.getElementById('screen7')
      };

      // Check if all required elements exist
      const allElementsExist = Object.values(elements).every(el => el !== null);

      if (!allElementsExist) {
        return;
      }

      // Only proceed with htmlToImage if elements exist
      if (elements.header1) setdataImg(await htmlToImage.toPng(elements.header1));
      if (elements.screen1) setdataImg1(await htmlToImage.toPng(elements.screen1));
      if (elements.screen2) setdataImg2(await htmlToImage.toPng(elements.screen2));
      if (elements.screen3) setdataImg3(await htmlToImage.toPng(elements.screen3));
      if (elements.screen4) setdataImg4(await htmlToImage.toPng(elements.screen4));
      if (elements.screen5) setdataImg5(await htmlToImage.toPng(elements.screen5));
      if (elements.screen6) setdataImg6(await htmlToImage.toPng(elements.screen6));
      if (elements.screen7) setdataImg7(await htmlToImage.toPng(elements.screen7));

      setReady(true);
    } catch (error) {
      console.error('Error in DataLoad:', error);
      // Don't set ready to true if there was an error
    }
  };


  const styles = {
    page: {
      display: 'flex',
      flexDirection: "row",
      flexWrap: 'wrap',
      padding: '40px'
    },
  }

  const MyDoc = () => (<Document style={{ width: "100%" }}>
    <Page size="A2" style={styles.page}>
      <Text style={{ fontSize: '24px', fontWeight: '900', marginBottom: "10px" }}>Wellness & CGM Monitoring Report</Text>
      <View style={{ flex: 1, flexGrow: 10, flex: '0 0 100%', paddingBottom: '10px' }}>
        <Image src={load} ></Image>
      </View>
      <View style={{ flex: 1, flexGrow: 7, paddingRight: '20px' }}>
        <Image src={load1} ></Image>
        <Image src={load2} ></Image>
        <Image src={load3} ></Image>
        <Image src={load4} ></Image>
        <Image src={load5} ></Image>
        <Image src={load6} ></Image>
      </View>
      <View style={(styles.section, { flex: 1, flexGrow: 3 })}>
        <Image src={load7} ></Image>
        {/*  <Image src={load8} ></Image> */}
        {/* <Image src={load9} ></Image> */}
      </View>
    </Page>
  </Document>);
  //const MyDoc1 = () => ( <Document><Page style={{ height: "50vh", width: "100%"}} ><View ><Image src={load1} /></View></Page></Document>);

  return (

    <div className="App">
      <div className="page-wrpper profilepage" >
        <Header />
        <div className='content-wrapper'>
          <div className='header-area'>

            <div className='header-top'>
              <div className='left-content' >
                <div className='wrapper' status={today ? "active" : null}>
                </div>
              </div>
              <div className='right-content'>
                <Link className='adminlogin' to={'/Adminlogin'} target="_blank" rel="noopener noreferrer">Database Admin</Link>
                <span className='current-user'><img alt="user" src={userImage} />
                  <span className='user-details'><span className='username'>{userName}</span> <span className='userrole'>{role}</span></span>

                  <span className='user-popup'><button onClick={logout}>Logout</button></span>
                </span>
              </div>
            </div>

            <div className='header-left'>

            </div>


            <div className='header-right'>
              {load.length && load1.length && load2.length && load3.length && load4.length && load5.length && load6.length && load7.length && /* load8.length && */ /* load9.length && */ ready === true ? <>
                <PDFDownloadLink document={<MyDoc />} id="pdflink" fileName={'Deatils-' + UID + '-' + DATE + '.pdf'}>
                  {({ blob, url, loading, error }) =>
                    loading ? 'PDF' : 'PDF'
                  }

                </PDFDownloadLink></> : ''}


            </div>

          </div>

          <div className='main-content' >

            {/*  {loading===true ? <Loader />: ''} */}

            {profileData.map(
              ({
                created_at, gender, dob, firstname, email,
                goals, objective, glucose_level,
                height,
                blood_pressure,
                is_registered, lastname, mobile_number,
                pulse, sleep_duration, sleep_quality, stress_level, updated_at, uuid,
                weight, medications, group_name, last_active,
                weight_unit, height_unit // <-- add these here
              }, index) => (
                <div key={index}>
                  {localStorage.setItem("nickname", firstname + ' ' + lastname)}
                  <div className='user-title-bar' id='header1'>
                    <div>
                      {prvUser === 'undefined' || role !== 'admin' ? '' : (<Link className='prev-arrow' to={'/user'} onClick={() => { setSelectedPatient(prvUser); refresh(); resetTime(); }}><IconChevronLeft /></Link>)}
                      {firstname} {lastname}
                      {nxtUser === 'undefined' || role !== 'admin' ? '' : (<Link className='next-arrow' to={'/user'} onClick={() => { setSelectedPatient(nxtUser); refresh(); resetTime(); }}><IconChevronRight /></Link>)}</div>
                    <div className='filter item datefilter'>
                      <div className='weekset'>
                        <span className='week previos' onClick={() => changeWeek()}><IconArrowLeft></IconArrowLeft></span>
                        <span className='week start'>{startDay} -</span>
                        <span className='week start'>{endDay}</span>
                        {moment(DATE).isBefore(moment(), "day") ? <>
                          <span className='week previos next' onClick={() => changeWeekNxt()}><IconArrowRight /></span>
                        </> : ''}
                      </div>
                      <div className="filter-title" ><DatePicker isClearable={false} dateFormat="MMM dd, yyyy" selected={moment(DATE).toDate()} placeholderText={moment(new Date()).format("MMM DD, YYYY")} onChange={(date) => { setDate(date); setStartDate(date); setToday(''); setloading(true); refresh() }} /> <IconCalendar size={20} /></div>
                    </div>
                  </div>

                  <div className='user-data-content'>
                    <div className='left-content'>
                      <div id="screen1">
                        <div className='col col-45'>
                          <div className='col-wrapper two-col'>
                            <div className='user-header'>
                              <div className='user-pic'></div>
                              <div className='user-info'>
                                <span className='usernamr'> {firstname} {lastname}</span>
                                <span className='gender-age'>{gender} / {-(moment(dob).diff(moment(), 'years'))}</span>
                              </div>
                            </div>
                            <div className='item'>
                              <span className='label'>Phone</span>
                              <span className='text'> {mobile_number}</span>
                            </div>
                            <div className='item'>
                              <span className='label'>Email</span>
                              <span className='text'> {email}</span>
                            </div>
                            {/* <div className='item'>
                        <span className='label'>Membership</span>
                        <span className='text'> Basic</span>
                    </div> */}
                            <div className='item'>
                              <span className='label'>Objective</span>
                              <span className='text'> {objective === 'g' ? 'Glucose Control' : ''} {objective === 'w' ? 'Weight Loss' : ''} {objective === 'gw' ? 'Glucose Control | Weight Loss' : ''}</span>
                            </div>
                            {/* <div className='item'>
                        <span className='label'>Goal</span>
                        <span className='text'><ul>{body_weight_goal===null ? '' :<li>Body Weight - {body_weight_goal} kg</li>} {meal_goal === 'null'? '' :<li>Daily calories intake - {meal_goal} cal</li>} </ul></span>
                    </div> */}
                            <div className='item'>
                              <span className='label'>Member since</span>
                              <span className='text'>{dayjs.unix(created_at).format("DD MMM YYYY")}</span>
                            </div>
                            <div className='item'>
                              <span className='label'>Group</span>
                              <span className='text'>{group_name}</span>
                            </div>
                            <div className='item inline-items'>
                              <div>
                                <span className='label'>Device</span>
                                <span className='text'>{userPlatform || '-'}</span>
                              </div>
                              <div>
                                <span className='label'>Device Id</span>
                                <span className='text'>{currentDeviceId || '-'}</span>
                              </div>
                            </div>
                            <div className='item inline-items'>
                              <div>
                                <span className='label'>Sensor Start</span>
                                <span className='text'>
                                  {sensorStartData?.start_date
                                    ? moment(sensorStartData.start_date).format('DD MMM YYYY')
                                    : '-'}
                                </span>
                              </div>
                              <div>
                                <span className='label'>Sensor End</span>
                                <span className='text'>
                                  {sensorStartData?.end_date
                                    ? moment(sensorStartData.end_date).format('DD MMM YYYY')
                                    : '-'}
                                </span>
                              </div>
                            </div>
                            <div className='item'>
                              <span className='label'>Last active</span>
                              <span className='text'>
                                {(() => {
                                  if (!last_active) return '-';
                                  // Handle Unix timestamp (number)
                                  if (typeof last_active === 'number') {
                                    return moment.unix(last_active).format("DD MMM YYYY");
                                  }
                                  // Handle Unix timestamp as string (all digits)
                                  if (typeof last_active === 'string' && /^\d+$/.test(last_active)) {
                                    return moment.unix(parseInt(last_active)).format("DD MMM YYYY");
                                  }
                                  // Handle various string formats
                                  const formats = [
                                    'YYYY-MM-DDTHH:mm:ss',
                                    'YYYY-MM-DDTHH:mm:ssZ',
                                    'YYYY-MM-DD HH:mm:ss',
                                    'YYYY-MM-DD',
                                    'DD MMM YYYY',
                                    moment.ISO_8601
                                  ];
                                  const parsed = moment(last_active, formats, true);
                                  return parsed.isValid() ? parsed.format("DD MMM YYYY") : '-';
                                })()}
                              </span>
                            </div>


                          </div>
                        </div>
                        <div className='col col-55'>
                          <h2>Meals & Health</h2>
                          <div>
                            {/* Health Metrics Grid - 2 rows of 4 */}
                            <div className='health-metrics-grid'>
                              {/* Medications */}
                              <div className='metric-card'>
                                <span className='metric-icon'><img src={medicinIco} alt="medications" /></span>
                                <div className='metric-content'>
                                  <span className='metric-label'>Medications</span>
                                  {medications && medications !== "No data" ? (
                                    Array.isArray(medications) ? (
                                      (() => {
                                        const currentDateStr = moment(DATE).format('YYYY-MM-DD');
                                        const todaysMedications = medications.filter(med => {
                                          const medDate = med.date || med.created_at || med.log_time;
                                          if (!medDate) return false;
                                          return moment(medDate).format('YYYY-MM-DD') === currentDateStr;
                                        });
                                        return todaysMedications.length > 0 ? (
                                          todaysMedications.map((med, i) => (
                                            <span className='metric-value' key={i}>
                                              {med.medication_name}
                                              {med.value && med.medication_type && ` (${med.value} ${med.medication_type})`}
                                            </span>
                                          ))
                                        ) : (
                                          <span className='metric-value muted'>No data</span>
                                        );
                                      })()
                                    ) : (
                                      <span className='metric-value'>{medications}</span>
                                    )
                                  ) : (
                                    <span className='metric-value muted'>No data</span>
                                  )}
                                </div>
                              </div>

                              {/* Blood Pressure */}
                              <div className='metric-card'>
                                <span className='metric-icon'><img src={bpIco} alt="blood pressure" /></span>
                                <div className='metric-content'>
                                  <span className='metric-label'>Blood Pressure</span>
                                  <span className='metric-value'>
                                    <strong>{highRanges.length > 0 ? highRanges.join(', ') : 'No data'}</strong>
                                    {highRanges.length > 0 ? ' / ' : ''}
                                    <strong>{lowRanges.length > 0 ? lowRanges.join(', ') : ''}</strong>
                                    {highRanges.length > 0 ? ' mmHg' : ''}
                                  </span>
                                </div>
                              </div>

                              {/* Pulse */}
                              <div className='metric-card'>
                                <span className='metric-icon'><img src={pulsIco} alt="pulse" /></span>
                                <div className='metric-content'>
                                  <span className='metric-label'>Pulse</span>
                                  <span className='metric-value'>
                                    <strong>{latestPulse || pulse?.pulse_rate || 'No data'}</strong>
                                    {(latestPulse || pulse?.pulse_rate) ? ' BPM' : ''}
                                  </span>
                                </div>
                              </div>

                              {/* BMI */}
                              <div className='metric-card'>
                                <span className='metric-icon'><img src={htIco} alt="bmi" /></span>
                                <div className='metric-content'>
                                  <span className='metric-label'>BMI</span>
                                  <span className='metric-value'>
                                    <strong>
                                      {(() => {
                                        const w = weightData?.weight != null ? parseFloat(weightData.weight) : null;
                                        const h = typeof height === 'number' ? height : parseFloat(height);
                                        if (w && !isNaN(h) && h > 0) {
                                          const weightKg = w * 0.45359237;
                                          const heightM = (height_unit || 'cm') === 'ft'
                                            ? h * 0.3048
                                            : (height_unit || 'cm') === 'in'
                                              ? h * 0.0254
                                              : h / 100;
                                          return (weightKg / (heightM * heightM)).toFixed(1);
                                        }
                                        return 'No data';
                                      })()}
                                    </strong>
                                    {(() => {
                                      const w = weightData?.weight != null ? parseFloat(weightData.weight) : null;
                                      const h = typeof height === 'number' ? height : parseFloat(height);
                                      return '';
                                    })()}
                                  </span>
                                </div>
                              </div>

                              {/* Weight + Body Fat + Muscle Mass (combined) */}
                              <div className='metric-card'>
                                <span className='metric-icon'><img src={wtIco} alt="weight" /></span>
                                <div className='metric-content'>
                                  <span className='metric-label'>Weight</span>
                                  <span className='metric-value'>
                                    <strong>{weightData?.weight != null ? parseFloat(weightData.weight).toFixed(2) : 'No data'}</strong>
                                    {weightData?.weight != null ? ' lbs' : ''}
                                  </span>
                                  <span className='metric-sub'>Body Fat: <strong>{weightData?.body_fat != null && weightData.body_fat !== 0 ? `${weightData.body_fat}%` : 'N/A'}</strong></span>
                                  <span className='metric-sub'>Muscle Mass: <strong>{weightData?.muscle_mass != null && weightData.muscle_mass !== 0 ? `${weightData.muscle_mass}%` : 'N/A'}</strong></span>
                                  {weightData?.date && <span className='metric-date'>Updated {moment(weightData.date).format('DD MMM YYYY')}</span>}
                                </div>
                              </div>

                              {/* Fasting Glucose */}
                              <div className='metric-card'>
                                <span className='metric-icon'><img src={fgIco} alt="fasting glucose" /></span>
                                <div className='metric-content'>
                                  <span className='metric-label'>Fasting Glucose</span>
                                  <span className='metric-value'>
                                    <strong>{glucose_level}</strong> {glucose_level === 'No data' ? '' : 'mmol/l'}
                                  </span>
                                </div>
                              </div>

                              {/* Sleep Condition */}
                              <div className='metric-card'>
                                <span className='metric-icon'><img src={scIco} alt="sleep" /></span>
                                <div className='metric-content'>
                                  <span className='metric-label'>Sleep</span>
                                  <span className='metric-value'>
                                    <strong>{latestSleepDuration != null ? parseFloat(latestSleepDuration).toFixed(2) : sleep_duration != null ? parseFloat(sleep_duration).toFixed(2) : 'No data'}</strong>
                                    {(latestSleepDuration != null || sleep_duration != null) ? ' Hrs' : ''}
                                  </span>
                                </div>
                              </div>

                              {/* Height */}
                              <div className='metric-card'>
                                <span className='metric-icon'><img src={htIco} alt="height" /></span>
                                <div className='metric-content'>
                                  <span className='metric-label'>Height</span>
                                  <span className='metric-value'>
                                    {height ? (() => {
                                      const cm = (height_unit || 'cm') === 'cm' ? height : height * 2.54;
                                      const totalIn = cm / 2.54;
                                      const ft = Math.floor(totalIn / 12);
                                      const inch = Math.round(totalIn % 12);
                                      return <><strong>{ft}</strong> ft <strong>{inch}</strong> in</>;
                                    })() : <strong>No data</strong>}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div id="screen2">
                        <Suspense fallback={<div className='spinner-wrapper'><Loader /></div>}><Userglucose /></Suspense>
                      </div>
                      
                      {/* Secondary components load after glucose charts are prioritized */}
                      {secondaryComponentsReady ? (
                        <>
                          <div id="screen3">
                            <Suspense fallback={<div className='spinner-wrapper'><Loader /></div>}><Usermeals /></Suspense>
                          </div>

                          <div id="screen4">
                            <Suspense fallback={<div className='spinner-wrapper'><Loader /></div>}><Userexercise /></Suspense>
                          </div>

                          <div id="screen4b">
                            <Suspense fallback={<div className='spinner-wrapper'><Loader /></div>}><CalorieTracker /></Suspense>
                          </div>
                        </>
                      ) : (
                        <>
                          <div id="screen3" className='spinner-wrapper'><Suspense fallback={null}><Loader /></Suspense></div>
                          <div id="screen4" className='spinner-wrapper'><Suspense fallback={null}><Loader /></Suspense></div>
                          <div id="screen4b" className='spinner-wrapper'><Suspense fallback={null}><Loader /></Suspense></div>
                        </>
                      )}

                      <div id="screen5">
                        <Suspense fallback={<div className='spinner-wrapper'><Loader /></div>}><Userweightheight /></Suspense>
                      </div>

                      <div id="screen6">
                        <Suspense fallback={<div className='spinner-wrapper'><Loader /></div>}><Userwellnessprofile /></Suspense>
                      </div>
                    </div>
                    <div className='right-content'>

                      <div id="screen8">

                        <div className='col col-100'>

                          <div className='col-group'>
                            <div className='col-wrapper appointments insights'>

                              <h2 > Shared with Doctors</h2>

                              <>
                                {doctorData && doctorData.map((data, i) => (
                                  <div key={i} className='item shared-deatils'>

                                    <div className="ele name">{data.name}  </div>
                                    <div className="ele email">{data.email}  </div>
                                    <div className="ele phone">{data.phone}  </div>
                                    <div className="ele date"> {moment(data.created_at).format('DD MMM YYYY')}  </div>

                                  </div>
                                ))}</>


                            </div>
                          </div>

                        </div>
                      </div>


                      <div id="screen9">

                        <div className='col col-100'>

                          <div className='col-group'>
                            <div className='col-wrapper appointments insights'>

                              <h2 >User Notes</h2>

                              {userNotes.length > 0 ? (
                                userNotes.slice(0, 7).map((note, index) => (
                                  <div key={note.id || note.created_at || index} className='item shared-deatils note-card' style={{ overflow: 'hidden', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                                    <div className="note-content" style={{ overflow: 'hidden', textOverflow: 'ellipsis', wordWrap: 'break-word', overflowWrap: 'break-word' }}><strong>Note : </strong> {note.content}</div>
                                    <div className="note-footer">
                                      <div className="note-type-badge">Type : {note.note_type}</div>
                                      <div className="note-date">{moment(note.created_at).format('DD MMM YYYY')}</div>
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <div className='item shared-deatils note-card'>
                                  <div className="note-content">No notes available</div>
                                </div>
                              )}

                            </div>
                          </div>

                        </div>
                      </div>

                      <div id="screen10">
                        <div className='col col-100'>
                          <div className='col-group'>
                            <div className='col-wrapper appointments insights'>

                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 0 }}>
                                <h2 style={{ margin: 0, borderBottom: 'none' }}>AI Insights</h2>
                                {(dailyInsight || weeklyInsight) && (
                                  <div style={{ 
                                    display: 'inline-flex', 
                                    alignItems: 'stretch', 
                                    marginRight: '20px',
                                    borderRadius: '6px',
                                    overflow: 'hidden',
                                    border: '1px solid #d0d0d0',
                                    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
                                    flexShrink: 0
                                  }}>
                                    <button
                                      onClick={() => setShowWeekly(false)}
                                      disabled={!dailyInsight}
                                      style={{
                                        background: !showWeekly && dailyInsight ? '#0051A6' : '#e0e0e0',
                                        color: !showWeekly && dailyInsight ? '#fff' : '#999',
                                        border: 'none',
                                        borderRadius: '0',
                                        borderRight: '1px solid #d0d0d0',
                                        padding: '8px 16px',
                                        cursor: dailyInsight ? 'pointer' : 'not-allowed',
                                        fontSize: '14px',
                                        fontWeight: !showWeekly ? 600 : 400,
                                        transition: 'all 0.2s ease',
                                        whiteSpace: 'nowrap',
                                        flex: '0 0 auto'
                                      }}
                                    >
                                      Daily
                                    </button>
                                    <button
                                      onClick={() => setShowWeekly(true)}
                                      disabled={!weeklyInsight}
                                      style={{
                                        background: showWeekly && weeklyInsight ? '#0051A6' : '#e0e0e0',
                                        color: showWeekly && weeklyInsight ? '#fff' : '#999',
                                        border: 'none',
                                        borderRadius: '0',
                                        padding: '8px 16px',
                                        cursor: weeklyInsight ? 'pointer' : 'not-allowed',
                                        fontSize: '14px',
                                        fontWeight: showWeekly ? 600 : 400,
                                        transition: 'all 0.2s ease',
                                        whiteSpace: 'nowrap',
                                        flex: '0 0 auto'
                                      }}
                                    >
                                      Weekly
                                    </button>
                                  </div>
                                )}
                              </div>
                              <div style={{ width: '100%', height: '1px', backgroundColor: 'rgba(145, 158, 171, 0.32)', marginTop: '0', marginBottom: '15px' }}></div>

                              {(() => {
                                const insight = showWeekly ? weeklyInsight : dailyInsight;
                                
                                if (!insight) {
                                  return (
                                    <div className='item shared-deatils note-card'>
                                      <div className="note-content">
                                        {showWeekly ? 'No weekly summary available' : 'No daily insight available'}
                                      </div>
                                    </div>
                                  );
                                }
                                
                                const insightKey = insight.id || insight.record_id || `insight-${showWeekly ? 'weekly' : 'daily'}`;
                                let formattedDate;
                                
                                if (showWeekly && insight.record_id && insight.record_id.includes('::weekly::')) {
                                  // Parse weekly date range from record_id: {uuid}::weekly::{start}::{end}
                                  const parts = insight.record_id.split('::');
                                  if (parts.length >= 4) {
                                    const startDate = moment(parts[2]).format('MMM D');
                                    const endDate = moment(parts[3]).format('MMM D, YYYY');
                                    formattedDate = `Week of ${startDate} - ${endDate}`;
                                  } else {
                                    formattedDate = moment(insight.analysis_date || insight.generated_at).format('dddd, MMMM D, YYYY');
                                  }
                                } else {
                                  formattedDate = moment(insight.analysis_date || insight.generated_at).format('dddd, MMMM D, YYYY');
                                }
                                
                                // Remove "Weekly Health Insights" header from markdown content if it's a weekly insight
                                let markdownContent = insight.markdown_content || '';
                                if (showWeekly) {
                                  // Remove lines that start with ## Weekly Health Insights (with or without trailing text)
                                  markdownContent = markdownContent.replace(/^##\s*Weekly\s+Health\s+Insights.*$/gmi, '').trim();
                                  // Also remove any leading empty lines
                                  markdownContent = markdownContent.replace(/^\n+/, '');
                                }
                                
                                return (
                                  <div key={insightKey} className='item shared-deatils note-card' style={{ width: 'calc(100% - 40px)', maxWidth: 'calc(100% - 40px)', overflow: 'hidden', wordWrap: 'break-word', overflowWrap: 'break-word', boxSizing: 'border-box', margin: '0 20px 15px' }}>
                                    <div style={{ 
                                      fontSize: '16px', 
                                      fontWeight: 600, 
                                      color: '#0051A6', 
                                      marginTop: '10px',
                                      marginBottom: '12px',
                                      paddingTop: '10px',
                                      paddingBottom: '12px',
                                      borderBottom: '2px solid #0051A6',
                                      width: 'calc(100% - 40px)',
                                      maxWidth: 'calc(100% - 40px)',
                                      overflowWrap: 'break-word',
                                      wordBreak: 'break-word',
                                      boxSizing: 'border-box'
                                    }}>
                                      {formattedDate}
                                    </div>
                                    <div className="note-content" style={{ width: '100%', maxWidth: '100%', overflow: 'hidden', wordWrap: 'break-word', overflowWrap: 'break-word', boxSizing: 'border-box' }}>
                                      <div style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                                        <ReactMarkdown remarkPlugins={[remarkGfm]} skipHtml={true}>{markdownContent}</ReactMarkdown>
                                      </div>
                                    </div>
                                    <div style={{
                                      marginTop: '0',
                                      paddingTop: '8px',
                                      borderTop: '1px solid rgba(145, 158, 171, 0.32)',
                                      fontSize: '12px',
                                      color: '#919EAB',
                                      fontStyle: 'italic',
                                      textAlign: 'center',
                                      width: 'calc(100% - 40px)',
                                      marginLeft: '20px',
                                      marginRight: '20px',
                                      boxSizing: 'border-box'
                                    }}>
                                      For informational purposes only. Consult your doctor for medical advice.
                                    </div>
                                  </div>
                                );
                              })()}

                            </div>
                          </div>
                        </div>
                      </div>

                      <div id="screen7">
                        <Suspense fallback={<div className='spinner-wrapper'><Loader /></div>}><Insights /></Suspense>
                      </div>

                      {/*  < div id="screen8">          
                          <div className='col col-100'>
                  
                  <div className='col-group'>
                  <div className='col-wrapper appointments chat'>
                  
                      <h2  onClick={()=> toggleActive()}  className= { toggle === true ? 'hide' :  'show'  }  style={{margin:"0"}}><img src={chatIco} /> Chat -  {firstname} {lastname} <span className='collapsible-icon'><IconCircleArrowUp /></span></h2>
                     */} {/*  { toggle === true ? <>  */}
                      {/* <Suspense */} {/* /* fallback={<div className='spinner-wrapper'><Loader/></div>}  /* <Chatappbox></Chatappbox></Suspense> */}
                      {/*  <Suspense fallback={<div className='spinner-wrapper'><Loader/></div>} > <UserChat></UserChat></Suspense> */}

                      {/*  </> : '' */}
                      {/*  </div>
                  
                  </div>
                </div>
                </div> */}

                      {/*                 <div id="screen9">
                <Suspense fallback={<div className='spinner-wrapper'><Loader/></div>}><Userappointment /></Suspense>
                  </div> */}
                    </div>
                  </div>


                </div>

              )
            )}



          </div>

        </div>

      </div>

      {/* AI Chatbot Modal */}
      <ChatbotModal />

    </div>


  );

}

export default User;
